import React from "react";
import PropTypes from  "prop-types";

function LightContentB(props) {
  return (
    <section className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap w-full mb-20">
          <div className="lg:w-1/2 w-full mb-6 lg:mb-0">
            <h1 className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
              Your Documents
            </h1>
            <div className={`h-1 w-20 bg-${props.theme}-500 rounded`}></div>
          </div>
          <p className="lg:w-1/2 w-full leading-relaxed text-gray-500">
           All Documents
          </p>
        </div>
        <div className="flex flex-wrap -m-4">
          <div className="xl:w-1/4 md:w-1/2 p-4">
            <div className="bg-gray-100 p-6 rounded-lg">
              <img
                className="h-40 rounded w-full object-cover object-center mb-6"
                src="https://dummyimage.com/720x400"
                alt="content"
              />
              <h3 className={`tracking-widest text-${props.theme}-500 text-xs font-medium title-font`}>
                SUBTITLE
              </h3>
              <h2 className="text-lg text-gray-900 font-medium title-font mb-4">
                Adhaar
              </h2>
              <p className="leading-relaxed text-base">
                Adhaar No.
              </p>
            </div>
          </div>
          <div className="xl:w-1/4 md:w-1/2 p-4">
            <div className="bg-gray-100 p-6 rounded-lg">
              <img
                className="h-40 rounded w-full object-cover object-center mb-6"
                src="https://dummyimage.com/721x401"
                alt="content"
              />
              <h3 className={`tracking-widest text-${props.theme}-500 text-xs font-medium title-font`}>
                SUBTITLE
              </h3>
              <h2 className="text-lg text-gray-900 font-medium title-font mb-4">
                Pan Card
              </h2>
              <p className="leading-relaxed text-base">
                Pan No.
              </p>
            </div>
          </div>
          <div className="xl:w-1/4 md:w-1/2 p-4">
            <div className="bg-gray-100 p-6 rounded-lg">
              <img
                className="h-40 rounded w-full object-cover object-center mb-6"
                src="https://dummyimage.com/722x402"
                alt="content"
              />
              <h3 className={`tracking-widest text-${props.theme}-500 text-xs font-medium title-font`}>
                SUBTITLE
              </h3>
              <h2 className="text-lg text-gray-900 font-medium title-font mb-4">
                 Passport
              </h2>
              <p className="leading-relaxed text-base">
                 Number
              </p>
            </div>
          </div>
          <div className="xl:w-1/4 md:w-1/2 p-4">
            <div className="bg-gray-100 p-6 rounded-lg">
              <img
                className="h-40 rounded w-full object-cover object-center mb-6"
                src="https://dummyimage.com/723x403"
                alt="content"
              />
              <h3 className={`tracking-widest text-${props.theme}-500 text-xs font-medium title-font`}>
                SUBTITLE
              </h3>
              <h2 className="text-lg text-gray-900 font-medium title-font mb-4">
                Driving Lisence
              </h2>
              <p className="leading-relaxed text-base">
                DL number
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

LightContentB.defaultProps = {
  theme: 'indigo'
};

LightContentB.propTypes = {
  theme: PropTypes.string.isRequired
};

export default LightContentB;
